import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'helpers/translateHelper';
import {
    IconAnomalyDetection,
    IconCondition,
    IconRefresh
} from 'svgIcons/MotionPortalIcons';
import { maxAnomalyLevel } from './constants';
import { OVER_ALL_STATUS } from '../../constants';

const MotorAssetStatusIndicator = ({
    anomalyDetectionKPI,
    title,
    levelLabel,
    isRetraining,
    isPrivilegedUser,
    setRetrainingModel,
    getAnomalyOverallLevel
}) => {
    const condition = OVER_ALL_STATUS[anomalyDetectionKPI?.condition];
    const isTolerable = condition === OVER_ALL_STATUS.Tolerable;
    const isUnknown = condition === OVER_ALL_STATUS.Unknown;

    const currentLevel = (() => {
        if (isTolerable) { return `${getAnomalyOverallLevel()}/${maxAnomalyLevel}`; }
        if (isUnknown) { return anomalyDetectionKPI?.condition; }
        return `0/${maxAnomalyLevel}`;
    })();

    const latestAnomalyLevel = `${levelLabel}: ${currentLevel}`;
    const Iconanomaly = isTolerable
        ? <span><IconAnomalyDetection /></span>
        : <span><IconCondition condition={condition} /></span>;

    let retrainControl = null;
    if (isPrivilegedUser) {
        if (isRetraining) {
            retrainControl =
                <span className='retraining-badge' aria-disabled='true'>
                    <IconRefresh width={'16px'} height={'16px'} color={'rgba(0, 0, 0, 0.40)'} />
                    {translate('ABB.Powertrain.Frontend.retrainingLabel')}
                </span>
                ;
        } else {
            retrainControl =
                <button
                    type='button'
                    className='retrain-model-button'
                    onClick={() => setRetrainingModel(true)}
                >
                    <IconRefresh width={'16px'} height={'16px'} />
                    <span>{translate('ABB.Powertrain.Frontend.retrainModelLabel')}</span>
                </button>
                ;
        }
    }

    return (
        <div className='kpi_status_title'>
            <div className='retrain-model-container'>
                <b> {isRetraining ? null : Iconanomaly}{title} {isRetraining ? '' : `(${latestAnomalyLevel})`} </b>
                {retrainControl}
            </div>
            <div className='retrain-title-info'>
                {translate('ABB.Powertrain.Frontend.retrainModelDescription')}
            </div>
        </div>
    );
};

MotorAssetStatusIndicator.propTypes = {
    anomalyDetectionKPI: PropTypes.object,
    title: PropTypes.string,
    levelLabel: PropTypes.string,
    isRetraining: PropTypes.bool,
    isPrivilegedUser: PropTypes.bool,
    setRetrainingModel: PropTypes.func.isRequired,
    getAnomalyOverallLevel: PropTypes.func.isRequired
};

export default MotorAssetStatusIndicator;
